import React from 'react';

const NotAuth = () => (
    <div>Не авторизований користувач</div>
);
export default NotAuth;
